/** Códigos de error de los 3 endpoints del wizard que devuelven este shape
 *  (`validar-nombre`, `validar-geometria`, `guardar`) — el resto de la API
 *  sigue devolviendo texto plano en el body del 400, sin `code`. */
export type WizardValidationErrorCode =
  | "TIPO_INVALIDO"
  | "NOMBRE_DUPLICADO"
  | "GEOMETRIA_SOLAPADA"
  | "GEOMETRIA_INVALIDA"
  | "LOTE_NOMBRE_DUPLICADO"
  | "LOTE_SOLAPADO";

export type WizardValidationErrorResponse = {
  success: false;
  code: WizardValidationErrorCode;
  message: string;
};

/** Parsea el mensaje de error de `validar-nombre`/`validar-geometria`/
 *  `guardar` (gRPC-Web, ver `mapFincaWizardGrpcError`) — si tiene la forma
 *  `{ success, code, message }`, la devuelve completa;
 *  `null` si no parsea así (texto plano, u otro tipo de error). Usarlo
 *  cuando hace falta el `code` (ej. `RegistroFincaPaso6Render` decidiendo a
 *  qué paso mandar al usuario a corregir) — para solo mostrar el mensaje,
 *  alcanza con `parseWizardErrorMessage`. */
export function parseWizardError(
  error: unknown,
): WizardValidationErrorResponse | null {
  if (!(error instanceof Error)) return null;
  try {
    const parsed = JSON.parse(error.message) as Partial<WizardValidationErrorResponse>;
    if (typeof parsed.message === "string" && typeof parsed.code === "string") {
      return parsed as WizardValidationErrorResponse;
    }
  } catch {
    // no-op — no era JSON.
  }
  return null;
}

/** Extrae el mensaje limpio de un error 400 de estos mismos 3 endpoints; si
 *  no parsea como `{ success, code, message }`, devuelve `error.message`
 *  tal cual, igual que el resto de la API. */
export function parseWizardErrorMessage(error: unknown): string {
  const parsed = parseWizardError(error);
  if (parsed) return parsed.message;
  if (error instanceof Error) return error.message;
  return String(error);
}
